// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2iHwW","content":"styles_content__1WNi4"};